import { render, staticRenderFns } from "./newImage.vue?vue&type=template&id=25dd5e9c&scoped=true"
import script from "./newImage.vue?vue&type=script&lang=js"
export * from "./newImage.vue?vue&type=script&lang=js"
import style0 from "./newImage.vue?vue&type=style&index=0&id=25dd5e9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dd5e9c",
  null
  
)

export default component.exports